/**
 * 配置文件索引
 * 统一导出所有配置模块
 */

import { initializeGlobals } from './globals';
import { initializePlugins } from './plugins';
import { registerComponents } from './components';

// 样式和基础配置
import '@/styles/index.scss';
import '@/icons';
import '@/permission';

export function initializeApp() {
    // 初始化插件
    initializePlugins();

    // 注册组件
    registerComponents();

    // 初始化全局配置
    initializeGlobals();
}
